import { render, staticRenderFns } from "./PriceDiscount.vue?vue&type=template&id=72b346b6&scoped=true"
import script from "./PriceDiscount.vue?vue&type=script&lang=js"
export * from "./PriceDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b346b6",
  null
  
)

export default component.exports